import Model from '../Model'

export default class EstimateLabourRate extends Model {
    static async all(params = {}) {
        const config = {params: params}
        const data = await Http.get(route('api.v2.estimation.labour-rates.list'), config)
        return this.make(data)
    }

    static make(attributes = {}) {
        let obj = super.make(attributes);
        obj.forEach((l) => {
            l.costPerUnit = parseFloat(l.costPerUnit)
        })
        return obj
    }
}